import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getHero } from "../Actions/API/HeroActions"
import { APIHero } from "../Models/API/APIHero"

export function useHero(
    id?: number,
    skipFetch: boolean = false
): FetchState<APIHero> {
    const dispatch = useDispatch()
    const entry = useAppState(state =>
        id === undefined ? undefined : state.api.heros[id]
    )

    useEffect(() => {
        if (entry === undefined && id !== undefined && !skipFetch) {
            dispatch(getHero(id))
        }
    }, [dispatch, entry, skipFetch, id])

    return entry
}
